module.exports = __webpack_public_path__ + "static/dojazd-photo01-9142f59d1a124d7695eda03c72c8f32b.jpg";